import { Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { ErrorState, Skeleton } from "@/components/ui";

import { SpaceLayout } from "../features/console";
import { spaceByCode } from "../features/console/spaces/lib/address";
import { useSpaceRows } from "../features/console/spaces/lib/queries";
import { SPACE_TAB_IDS, type SpaceTab } from "../features/console/spaces/tabs";

/** One space, named by the join code its host hands out. The tab is the address, not state. */
export const Route = createFileRoute("/console/spaces/$joinCode")({
  component: SpaceRoute,
});

function tabOf(pathname: string): SpaceTab {
  const last = pathname.split("/").filter((one) => one !== "").pop() ?? "control";
  const found = SPACE_TAB_IDS.find((one) => one === last);
  return found ?? "control";
}

function SpaceRoute() {
  const { joinCode } = Route.useParams();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { rows, query } = useSpaceRows();
  const space = spaceByCode(rows, joinCode);

  if (query.isPending) return <Skeleton height={240} />;
  if (space === undefined) return <ErrorState headline="No such space" />;

  return (
    <SpaceLayout space={space} tab={tabOf(pathname)}>
      <Outlet />
    </SpaceLayout>
  );
}
